/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDiagnoses} from '@fortawesome/pro-duotone-svg-icons';

const HealthConditionIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faDiagnoses} {...props} />
);

export default HealthConditionIcon;
